/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { TEAM_NAME } from './teamName.constants.tsx';
import { fetchSuggestedTopics as fetchSuggestedTopicsService } from './fetchSuggestedTopics.tsx';
import type { State } from './SuggestedTopicState.types.tsx';

export const fetchSuggestedTopics =
	(projectId: number, analyticsEvent: UIAnalyticsEvent, activationId: string) =>
	async ({ getState, setState }: StoreActionApi<State>): Promise<void> => {
		try {
			setState({
				...getState(),
				topics: {
					...getState().topics,
					loading: true,
					error: null,
				},
			});

			const response = await fetchSuggestedTopicsService(projectId, activationId);

			setState({
				...getState(),
				topics: {
					data: response.topics,
					loading: false,
					error: null,
				},
			});

			fireTrackAnalytics(analyticsEvent, 'fetchTopics succeeded', {
				projectId,
				noOfTopics: response.topics.length,
				isFiltered: response.isFiltered,
			});

			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchTopics',
					packageName: 'jiraServicedeskKnowledgePerformance',
					teamName: TEAM_NAME,
				},
				error,
			});

			setState({
				...getState(),
				topics: {
					data: [],
					loading: false,
					error,
				},
			});
		}
	};
